const factor = 16 / 35;

export default function getSubAvatarSize(size: number)
{
    return factor * size;
}